<template>
  <section>
    <qx-search-box
        class="searchBox"
        ref="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        unitOptions: [], // 消费类型
        form: [
          { // 消费类型
            label: '消费类型',
            value: 'unit',
            type: 'select',
            default: 0,
            placeholder: '全部',
            options: [
              {label: '全部', value: 0},
              { label: '加油', value: 1 },
              { label: '加气', value: 2 },
            ],
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // RFID电子标签序列号
            label: 'RFID电子标签',
            value: 'labelCode',
            type: 'input',
            placeholder: '请输入RFID电子标签序列号',
          },
          { // 油气站名称
            label: '油气站名称',
            value: 'storeName',
            type: 'input',
            placeholder: '请输入油气站名称',
          },
          { // 加油时间
            label: '加油时间',
            value: 'scanTime',
            type: 'date',
            default: [],
            placeholder: '请选择加油时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 请求时间
            label: '请求时间',
            value: 'payTime',
            type: 'date',
            default: [],
            placeholder: '请选择请求时间',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  methods: {
    onChangeFromType (val) {
      const fromType = val || this.$refs.searchBox.getVal('fromType') || '4';
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'disabled',
        value: fromType !== '4',
        names: ['unit'],
      });
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.payTime && searchBoxData.payTime.length) { // 请求时间
        searchBoxData.payBeginTime = this.formatDate(searchBoxData.payTime[0]);
        searchBoxData.payEndTime = this.formatDate(searchBoxData.payTime[1]);
      }
      delete searchBoxData.payTime;
      if (searchBoxData.scanTime && searchBoxData.scanTime.length) { // 加油时间
        searchBoxData.scanBeginTime = this.formatDate(searchBoxData.scanTime[0]);
        searchBoxData.scanEndTime = this.formatDate(searchBoxData.scanTime[1]);
      }
      delete searchBoxData.scanTime;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'RECHARGE_CONSUME_RECORD_SOURCE_TYPE,RECHARGE_CONSUME_RECORD_CARD_TYPE,OIL_STATION_TYPE',
    });
    this.searchBoxData.unitOptions = [
      {
        label: '全部',
        value: 0,
      },
      ...enumsList[0],
    ];

    this.onChangeFromType();
  },
};
</script>

<style lang="scss" scoped>
</style>
